_.mixin(module.exports = {
  deepClone: function(object) {
    var clone;
    clone = _.clone(object);
    _.each(clone, function(value, key) {
      if (_.isObject(value)) {
        return clone[key] = _.deepClone(value);
      }
    });
    return clone;
  },
  isBlank: function(obj) {
    if (_.isString(obj)) {
      return !/\S/.test(obj);
    } else {
      return _.isEmpty(obj);
    }
  },
  escapeRegExp: function(str) {
    if (str != null) {
      return String(str).replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    } else {
      return '';
    }
  }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9jb21tb24vdW5kZXJzY29yZV9taXhpbnMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9jb21tb24vdW5kZXJzY29yZV9taXhpbnMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLENBQUMsQ0FBQyxLQUFGLENBQVEsTUFBTSxDQUFDLE9BQVAsR0FDTjtFQUFBLFNBQUEsRUFBVyxTQUFDLE1BQUQ7QUFDVCxRQUFBO0lBQUEsS0FBQSxHQUFRLENBQUMsQ0FBQyxLQUFGLENBQVEsTUFBUjtJQUNSLENBQUMsQ0FBQyxJQUFGLENBQU8sS0FBUCxFQUFjLFNBQUMsS0FBRCxFQUFRLEdBQVI7TUFDWixJQUFHLENBQUMsQ0FBQyxRQUFGLENBQVcsS0FBWCxDQUFIO2VBQ0UsS0FBTSxDQUFBLEdBQUEsQ0FBTixHQUFhLENBQUMsQ0FBQyxTQUFGLENBQVksS0FBWixFQURmOztJQURZLENBQWQ7V0FHQTtFQUxTLENBQVg7RUFPQSxPQUFBLEVBQVMsU0FBQyxHQUFEO0lBQ1AsSUFBRyxDQUFDLENBQUMsUUFBRixDQUFXLEdBQVgsQ0FBSDthQUNFLENBQUksSUFBSSxDQUFDLElBQUwsQ0FBVSxHQUFWLEVBRE47S0FBQSxNQUFBO2FBR0UsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxHQUFWLEVBSEY7O0VBRE8sQ0FQVDtFQWFBLFlBQUEsRUFBYyxTQUFDLEdBQUQ7SUFDWixJQUFHLFdBQUg7YUFDRSxNQUFBLENBQU8sR0FBUCxDQUFXLENBQUMsT0FBWixDQUFvQiw2QkFBcEIsRUFBbUQsTUFBbkQsRUFERjtLQUFBLE1BQUE7YUFHRSxHQUhGOztFQURZLENBYmQ7Q0FERiJ9
